import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "badge" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
  text: string
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.text), 1))
}
}

})